// extracted by mini-css-extract-plugin
export default {"TermsPage":"TermsPage_TermsPage__-J9j6"};